export default "__VITE_ASSET__0e4d9Nan__"